<script>
  import { router } from '@inertiajs/svelte'
  
  let { user = {}, alert = '', errors = {} } = $props();
  
  let email = $state(user.email || '');
  let passwordChallenge = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.patch('/identity/email', {
      email,
      password_challenge: passwordChallenge
    });
  }
  
  function resendVerification() {
    router.post('/identity/email_verification');
  }
  
  // Helper functions for errors
  function hasErrors() {
    return Object.keys(errors).length > 0;
  }
  
  function countErrors() {
    let count = 0;
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        count += errors[field].length;
      }
    }
    return count;
  }
  
  function getErrorMessages() {
    const messages = [];
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        errors[field].forEach(message => {
          messages.push(`${field} ${message}`);
        });
      }
    }
    return messages;
  }
</script>

<div class="email-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}
  
  {#if user.verified}
    <h1>Change your email</h1>
  {:else}
    <h1>Verify your email</h1>
    <p>We sent a verification email to the address below. Check that email and follow those instructions to confirm it's your email address.</p>
    <p>
      <button class="verification-button" onclick={resendVerification}>
        Re-send verification email
      </button>
    </p>
  {/if}
  
  {#if hasErrors()}
    <div class="error-summary">
      <h2>{countErrors()} {countErrors() === 1 ? 'error' : 'errors'} prohibited this user from being saved:</h2>
      
      <ul>
        {#each getErrorMessages() as message}
          <li>{message}</li>
        {/each}
      </ul>
    </div>
  {/if}
  
  <form onsubmit={submit}>
    <div class="form-group">
      <label for="email" class="form-label">New email</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="email" 
        type="email" 
        bind:value={email} 
        required 
        autofocus 
        class={errors.email ? 'form-input error' : 'form-input'}
      />
      {#if errors.email}
        <div class="error-message">{errors.email.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-group">
      <label for="password_challenge" class="form-label">Password</label>
      <input 
        id="password_challenge" 
        type="password" 
        bind:value={passwordChallenge} 
        required 
        autocomplete="current-password"
        class={errors.password_challenge ? 'form-input error' : 'form-input'}
      />
      {#if errors.password_challenge}
        <div class="error-message">{errors.password_challenge.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-actions">
      <button type="submit" class="save-button">Save changes</button>
    </div>
  </form>
  
  <br>
  
  <div>
    <a href="/" class="back-link">Back</a>
  </div>
</div>

<style>
  .email-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .alert {
    color: red;
    margin-bottom: 1rem;
  }
  
  .error-summary {
    background-color: #fee2e2;
    border: 1px solid #ef4444;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .error-summary h2 {
    color: #b91c1c;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .error-summary ul {
    margin: 0;
    padding-left: 1.25rem;
    color: #b91c1c;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-input.error {
    border-color: #ef4444;
    background-color: #fef2f2;
  }
  
  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .save-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .save-button:hover {
    background-color: #065f46;
  }
  
  .verification-button {
    background-color: #10b981;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .verification-button:hover {
    background-color: #059669;
  }
  
  .back-link {
    color: #047857;
    text-decoration: none;
  }
  
  .back-link:hover {
    text-decoration: underline;
  }
</style>